export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
      <rect x="1.5" y="1.5" width="37" height="37" rx="4" stroke="currentColor" strokeOpacity="0.28" strokeWidth="1.5" />
      <path d="M7 25 L20 10.5 L33 25" stroke="hsl(var(--accent))" strokeWidth="2.6" strokeLinejoin="round" strokeLinecap="round" />
      <path d="M8.5 29.5 H31.5" stroke="currentColor" strokeOpacity="0.55" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M8.5 33.5 H31.5" stroke="currentColor" strokeOpacity="0.32" strokeWidth="1.7" strokeLinecap="round" />
      <path d="M20 25 V33.5" stroke="hsl(var(--accent))" strokeOpacity="0.8" strokeWidth="1.3" />
    </svg>
  );
}

export function Logo({ variant = "full", className = "", markSize = 38, tone = "dark" }) {
  const textColor = tone === "light" ? "text-white" : "text-primary";
  const subColor = tone === "light" ? "text-white/60" : "text-muted-foreground";
  if (variant === "icon") return <LogoMark size={markSize} className={textColor + " " + className} />;
  const stacked = variant === "stacked";
  return (
    <div className={`flex ${stacked ? "flex-col items-center gap-1" : "items-center gap-3"} ${className}`}>
      <LogoMark size={markSize} className={`${textColor} shrink-0`} />
      <div className={`leading-none ${stacked ? "text-center mt-1" : ""}`}>
        <div className={`font-display font-extrabold tracking-tight text-lg ${textColor}`}>
          <span className="text-accent">12</span> STONE
        </div>
        <div className={`font-mono uppercase tracking-[0.28em] text-[9px] mt-1 ${subColor}`}>
          Development Group
        </div>
      </div>
    </div>
  );
}
